import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import axios from "axios";
import auth from "./auth";
import { test_ip } from "../services/constants"; // Ensure this is used or remove it if unnecessary
import { Dashen_Constants } from "../services/dashen_bank_constants";
import Button from "@mui/material/Button";

const appCode = Dashen_Constants.MINI_APP_CODE;
const appSecret = Dashen_Constants.appSecret;

const Test_working_last = () => {
  const [customerIdentifier, setCustomerIdentifier] = useState(null);
  const nav = useNavigate();

  // Callback handler
  const DashenCallback = (identifier) => {
    setCustomerIdentifier(identifier);
    console.log("customerIdentifier", identifier);
    alert("Callback received with identifier: " + identifier);
  };

  useEffect(() => {
    // Register the callback function
    window.DashenCallback = DashenCallback;
    const fetchAccessToken = () => {
      const saRequestPayload = JSON.stringify({
        functionName: "fetchAccessToken",
        params: {
          appcode: appCode,
          callbackName: "DashenCallback",
        },
      });

      if (window.dashenbanksuperapp) {
        window.dashenbanksuperapp.send(saRequestPayload);
      } else {
        console.error("Dashen Bank SuperApp is not available!");
      }
    };

    fetchAccessToken(); // Fetch access token on component mount
  }, []);

  // Effect to handle customerIdentifier when set
  useEffect(() => {
    const requestFabricToken = async () => {
      if (customerIdentifier) {
        const body = JSON.stringify({
          appcode: appCode,
          stage: "uat",
          customeridentifier: customerIdentifier,
        });

        try {
          const res = await axios.post(
            "https://sau.eaglelionsystems.com/v1.0/chatbirrapi/miniapps/apps/getfabrictoken",
            body,
            {
              headers: {
                "x-api-key": appSecret,
                "Content-Type": "application/json",
              },
            }
          );

          // Handle the response
          console.log("Response:", res.data);
          if (res.data.data && res.data.data.customer) {
            const { name, phoneNumber } = res.data.data.customer;

            // Prepare the body for the user login API
            const secondBody = JSON.stringify({
              name: name,
              phone: phoneNumber,
            });

            // Make the second request to the user login API
            const secondRes = await axios.post(
              `${test_ip}api/user/login_with_dashen_supperapp`,
              secondBody,
              {
                headers: {
                  "Content-Type": "application/json",
                },
              }
            );

            console.log("Second request response:", secondRes.data);
            if (secondRes.data.success) {
              // Handle successful login
              const user_data = {
                user_id: secondRes.data.user._id,
                unique_id: secondRes.data.user.unique_id,
                cart_id: secondRes.data.user.cart_id,
                phone: secondRes.data.user.phone,
                last_name: secondRes.data.user.last_name,
                first_name: secondRes.data.user.first_name,
                email: secondRes.data.user.email,
                country_id: secondRes.data.user.country_id,
                server_token: secondRes.data.user.server_token,
                order_count: secondRes.data.user.order_count,
                token: res.data.token, //token from the dashen superapp
              };

              console.log("User data received:", user_data);
              localStorage.setItem("user", JSON.stringify(user_data));
              auth.login(() => {
                nav("/home", { replace: true });
              });
            } else {
              console.error("Login failed:", secondRes.data.error_code);
            }
          }
        } catch (err) {
          console.error("Error in request:", err);
        }
      }
    };

    requestFabricToken(); // Call the function to request token
  }, [customerIdentifier]); // Dependency array to watch for changes

  // Function to be called on button click
  const handleLoginClick = () => {
    const saRequestPayload = JSON.stringify({
      functionName: "fetchAccessToken",
      params: {
        appcode: appCode,
        callbackName: "DashenCallback",
      },
    });

    if (window.dashenbanksuperapp) {
      window.dashenbanksuperapp.send(saRequestPayload);
    } else {
      console.error("Dashen Bank SuperApp is not available!!!!");
    }
  };

  return (
    <div className="b-login-page">
      <div className="b-contain" style={{ marginTop: "200px" }}>
        <div className="b-logo" style={{ width: "100%" }}>
          <img
            style={{
              display: "block",
              width: "80px",
              borderRadius: "50%",
              marginBottom: "20px",
              marginLeft: "auto",
              marginRight: "auto",
            }}
            src="zmall-logo.png"
            alt="zmall-logo"
          />
        </div>
        <div className="b-b-btn">
          <h4>
            Please login using Dashen super App to use ZMall Delivery. By
            pressing the Login button, you are allowing permission to use your
            phone Number and Name.
          </h4>
        </div>
        <Button className="b-login-btn" size="small" onClick={handleLoginClick}>
          Login
        </Button>
      </div>
    </div>
  );
};

export default Test_working_last;
